import { useSubscriptionLinkProps } from '@hooks/links/use-subscription-link-props'
import Button from '@ui/atoms/button'
import React, { type FC } from 'react'

type Props = {
  values: Array<{
    label: string
    value: string
  }>
}

export const SimulatorResponse: FC<Props> = ({ values }) => {
  const subscriptionProps = useSubscriptionLinkProps(
    '/credit-immobilier/demander-un-pret'
  )

  return (
    <div className="flex h-full flex-col items-center justify-center">
      {values.map(({ label, value }, i) => (
        <span key={`simulator-response-${i}`} className="text-center">
          <span className="text-230 font-medium leading-alternate">
            {value}
          </span>
          <p>{label}</p>
        </span>
      ))}
      <div className="mt-10">
        <Button {...subscriptionProps}>Demander un prêt</Button>
      </div>
    </div>
  )
}
